import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { FCRAWorker } from '@/types/turn-api';
import { AddAddressFormProps } from '../types';

const useController = ({ onClose }: AddAddressFormProps) => {
  const { handleSubmit } = useFormContext<FCRAWorker.Address>();
  const { runRequest } = useRunRequest();
  const { id: workerId } = useParams<{ id: string }>();

  const handleAddAddress = async (values: FCRAWorker.Address) => {
    const state = values?.state?.replace(/^US-/, '') ?? '';

    await runRequest({
      fetchType: 'CREATE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: workerId,
        target: TurnTargetsEnum.Addresses,
        data: { ...values, state },
      },
      mode: 'notify',
      notify: {
        onError: { message: 'Error: Address could not be added' },
        onSuccess: { message: 'Address added successfully', postAction: onClose },
      },
    });
  };

  return {
    handleAddAddress: handleSubmit(handleAddAddress),
  };
};

export default useController;
